module.exports = __webpack_public_path__ + "media/images/top/card-kaoawase-811265e5e5862116fbf1b7e33d33d117.jpg";